import React from "react"

import * as imageSectionStyles from "../styles/ImageSection.module.css"

import { ChildSelector } from "../helpers/ChildSelector"

import WPImage from "./_base/WPImage"
import WPCta from "./_base/WPCta"

export default function ImageSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const textStack = content.childNodes
    .filter(node => node.classNames === "content")
    .map(t => t.text)

  const imageTopPlacement =
    false || props.className.trim().split(/\s+/).includes(`icw-with-image-top`)

  return (
    <>
      <div
        className={`row ${props.className} ${imageSectionStyles.wrapper}`}
      >
        {(title || textStack.length > 0) && (
          <div className={`row ${imageSectionStyles}`}>
            <div
              className={`col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ${imageSectionStyles.wrapperContent}`}
            >
              {title && <h1 className={imageSectionStyles.title}>{title}</h1>}
              {textStack.length > 0 && <p className={imageSectionStyles.text}>{textStack}</p>}
            </div>
          </div>
        )}

        <div
          className={`row justify-content-center ${imageSectionStyles.wrapperImage}`}
        >
          {imageTopPlacement && (
            <WPImage
              holder={content}
              selector={`img-section`}
              className={`${imageSectionStyles.image}`}
            />
          )}
          {!imageTopPlacement && (
            <WPImage
              holder={content}
              selector={`img-section`}
              className={`${imageSectionStyles.image}`}
            />
          )}
        </div>
        {ChildSelector.select(content, "image-section-cta") && (
          <div className={`row ${imageSectionStyles.btnWrapper}`}>
            <WPCta
              holder={content}
              selector={`image-section-cta`}
              translate={true}
              className={`${imageSectionStyles.btn}`}
              pageContext={props.pageContext}
            />
          </div>
        )}
      </div>
    </>
  )
}
